import React from "react";

import Padlock from "../assets/secure_transfer/lock-icon.png";
import FcaLogo from "../assets/secure_transfer/fca-logo.png";
import VisaLogo from "../assets/secure_transfer/visa-logo.png";
import MasterLogo from "../assets/secure_transfer/mastercard-secureCode-logo.png";
import PciLogo from "../assets/secure_transfer/pci-dss.png";

function SecureTransfer(props) {
  return (
    <section className="my-5 py-5">
      <div className="w-100 linear-gradient-primary-bg rounded-15 px-3 pt-3 pb-5">
        <div className="d-flex">
          <div className="box-size-64-c me-2 me-sm-4">
            <img src={Padlock} alt="secure" className="img-fluid" />
          </div>
          <div className="d-flex flex-column flex-lg-row w-100 pt-3">
            <div className="max-width-380 mx-auto mt-3 mb-3 mt-lg-5 mb-lg-5">
              <h2 className="fs-1 text-dark text-center">
                Your money transfer is safe & secure with Tanaad
              </h2>
            </div>
            <div className="flex-basis-100 d-none d-lg-flex align-items-lg-center full-height px-lg-4">
              <div className="w-100 d-flex justify-content-around">
                <img
                  src={FcaLogo}
                  alt="Secure with fca"
                  className="max-width-78 d-block me-2"
                />
                <img
                  src={VisaLogo}
                  alt="Secure with Visa"
                  className="max-width-78 d-block me-2"
                />
                <img
                  src={MasterLogo}
                  alt="Secure with Mastercard"
                  className="max-width-78 d-block me-2"
                />
                <img
                  src={PciLogo}
                  alt="Secure with PCI DSS"
                  className="max-width-78 d-block me-2"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex d-lg-none align-items-lg-center full-height px-lg-4">
          <div className="w-100 d-flex justify-content-around flex-wrap">
            <img
              src={FcaLogo}
              alt="Secure with fca"
              className="max-width-64 d-block me-2 mb-3"
            />
            <img
              src={VisaLogo}
              alt="Secure with Visa"
              className="max-width-64 d-block me-2 mb-3"
            />
            <img
              src={MasterLogo}
              alt="Secure with Mastercard"
              className="max-width-64 d-block me-2 mb-3"
            />
            <img
              src={PciLogo}
              alt="Secure with PCI DSS"
              className="max-width-64 d-block me-2 mb-3"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SecureTransfer;
